module.exports = __webpack_public_path__ + "img/clinica.be00cbaa.svg";